import { EtiquetasGenerales_ES } from "./Genericos/EtiquetasGenerales_ES";

const EtiquetasModulo = {
  NombrePortal: {
    Et_Nombre: "Portal Nuevo Ingreso",
  },
  Home: {
    Et_lblHola: "Hola",
    Et_lblSaludosDia: "Bienvenido al Portal Nuevo Ingreso",
    Et_lblDescripcion:
      "Que tus metas no se detengan, empieza tu proyecto académico y haz que tus sueños se cumplan.",
    Et_lblRegistro: "Registro",
    Et_lblAdmision: "Admisión",
    Et_lblDatosPersonales: "Datos personales",
    Et_lblContactos: "Contactos",
    Et_lblSeleccion: "Selección",
    Et_lblRequisitosAdmision: "Requisitos de admisión",
    Et_lblCodigoVerificacion: "Código de verificación",
    Et_lblCodigoVerificacionDescripcion:
      "Por favor digite su código de verificación correspondiente.",
    Et_lblAdmisionProgramas: "Carrera",
    Et_lblAdmisionPlanes: "Programa",
    Et_lblDocumento: "Documento",
    Et_lblAdjuntar: "Adjuntar",
    Et_lblObtenerCodigo: "Reenviar código de verificación",
    Et_lblAdjuntosPendientes:
      "Hay requisitos de admisión pendientes de adjuntar a la documentación solicitada.",
    Et_lblEnviarAdmisionMsg:
      "Hemos recibido su solicitud de admisión. El personal de la institución estará validando la documentación y recibirá un correo electrónico con los pasos a seguir. ¡Muchas gracias por elegir nuestra institución!",
    Et_lblOrigen: "Origen",
    Et_InformacionAdicional: "Información Adicional",
    Et_lblcomenzar: "Comenzar",
  },
  InterfazDatosPersonales: {
    Et_TituloPrincipal: "Información Personal",
    Et_tblCusTipoCIF: "Tipo CIF",
    Et_tblCusTypeIdeFk: "Tipo de identificación",
    Et_tblCusTypeIdeFkShort: "Tipo de ID",
    Et_tblcusFullName: "Nombre completo",
    Et_tblCusLastName1: "Primer apellido",
    Et_tblCusLastName2: "Segundo apellido",
    Et_tblFechaNacimiento: "Fecha de nacimiento",
    Et_tblCusCivilStatusFkShort: "Est. civil",
    Et_tblCusCivilStatusFk: "Estado civil",
    Et_tblCusGenderFk: "Género",
    Et_tblValidIdeMinimo:
      "El número de identificación tiene menos dígitos ({0}) de los permitidos para el tipo de identificación seleccionado ({1}).",
    Et_tblValidIdeMaximo:
      "El número de identificación tiene más dígitos ({0}) de los permitidos para el tipo de identificación seleccionado ({1}).",
    Et_tblValidIdeFormato:
      "El número de identificación no tiene el formato requerido para el tipo de identificación seleccionado. {0}",
    Et_tblIdeFormato: "Formato válido: {0}.",
    Et_tblInvalidIde: "Número de identificación no válido.",
    Et_tblCusApellidoCasada: "Apellido de casada",
    Et_tblCusCorrelativoDPI: "Correlativo DPI",
    Et_tblCusDeptoNacimiento: "Departamento de nacimiento",
    Et_tblFechaVencimiento: "Fecha de vencimiento",
    Et_tblCusMuniNacimiento: "Municipio de nacimiento",
    Et_tblCusOcupacion: "Ocupación",
    Et_tblCusOrdenCedula: "Orden cédula",
    Et_tblCusPaisNacimiento: "País de nacimiento",
    Et_tblCusRegistroCedula: "Registro cédula",
    Et_tblCusVecindad: "Vecindad",
  },
  InterfazClienteContactInfo: {
    Et_tblAddress: "Direcciones",
    Et_tblAddressType: "Tipo de dirección",
    Et_tblCountry: "País",
    Et_tblProvince: "Provincia",
    Et_tblCanton: "Cantón",
    Et_tblDistrict: "Distrito",
    Et_tblNeighborhood: "Barrio",
    Et_tblExactAdress: "Dirección exacta",
    Et_tblPostalCode: "Código Postal",
    Et_tblContact: "Teléfonos",
    Et_tblPhoneType: "Tipo de teléfono",
    Et_tblPhone: "Teléfono",
    Et_tblCountryCode: "Código de país",
    Et_SelecAddTy: "Seleccione el tipo de dirección",
    Et_SelecContactTyp: "Seleccione el tipo de contacto",
    Et_SelecEmailTyp: "Seleccione el tipo de correo",
    Et_tblEmailTittle: "Correo electrónico",
    Et_tblEmailType: "Tipo de correo",
    Et_tblEmail: "Correo",
  },
  PlantillaCorreoToken: {
    Et_Hola: "Hola ",
    Et_TextoSuCodigo: "Su código de verificación es: ",
    Et_Gracias: "Gracias por usar nuestro portal.",
    Et_Asunto: "Código de verificación",
  },
  InterfazNacionalidad: {
    Et_tblCountrys: "Nacionalidades",
    Et_tblCIFs: "Tipos CIF",
    Et_SelecCIFs: "Tipo CIF",
    Et_tblCIF: "Tipo CIF",
    Et_SelecCountry: "País",
    Et_SelecTypeCountry: "Tipo nacionalidad",
    Et_tblCountry: "País",
    Et_tblTypeCountry: "Tipo nacionalidad",
    Et_tblNacionalidad: "Nacional",
    Et_tblRecidencia: "Residencia",
  },
  PagoEnLinea: {
    Et_TituloPrincipal: "Pago en Línea",
    Et_Descripcion: "Realice el pago de la factura con tarjeta crédito o débito",
    Et_Redireccion: "Serás redirigido a nuestra pasarela de pagos segura.",
    Et_TituloModalPago: "Completa tu pago",
    Et_DescripcionModalPago:
      "Para continuar con tu inscripción necesitas pagar el PIN de admisión.",
    Et_TotalAPagar: "Total a pagar",
    Et_AvisoRedireccion:
      "Serás redirigido a nuestra pasarela de pagos segura para completar la transacción.",
    Et_Cancelar: "Cancelar",
    Et_IrAPagar: "Ir a pagar",
    Et_TituloPagoPendiente: "Pago en proceso",
    Et_DescripcionPagoPendiente:
      "Ya tienes un pago en proceso. Cierra los otros procesos de pago abiertos en tu navegador antes de continuar.",
    Et_TituloPagoExitoso: "¡Tu pago fue un éxito!",
    Et_DescripcionPagoExitoso:
      "Tu pago fue recibido exitosamente. La institución revisará tus requisitos y te notificará los próximos pasos por correo electrónico.",
    Et_AvisoComprobante:
      "Revisa tu bandeja de entrada para encontrar el comprobante de pago.",
    Et_TituloPagoFallido: "Hubo un problema con tu pago",
    Et_DescripcionPagoFallido:
      "No pudimos confirmar tu pago. No se realizó ningún cobro o el proceso quedó incompleto. Puedes intentarlo nuevamente desde el portal de estudiantes.",
    Et_Salir: "Salir",
    Et_ContinuarAlInicio: "Continuar al inicio",
  },
};

const EtiquetasUnificadas = { ...EtiquetasGenerales_ES, ...EtiquetasModulo };

const Etiquetas_Es = {
  Idioma: "ES",
  Etiquetas: EtiquetasUnificadas,
};

export default Etiquetas_Es;
